var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-title-icon",style:(_vm.outterStyle)},[_c('v-icon',{attrs:{"size":"40","color":_vm.color},domProps:{"textContent":_vm._s(_vm.icon)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }